
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeRisorseGrid extends Serenity.EntityGrid<AssetEsperienzeRisorseRow, any> {
        protected getColumnsKey() { return AssetEsperienzeRisorseColumns.columnsKey; }
        protected getDialogType() { return AssetEsperienzeRisorseDialog; }
        protected getIdProperty() { return AssetEsperienzeRisorseRow.idProperty; }
        protected getInsertPermission() { return AssetEsperienzeRisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return AssetEsperienzeRisorseRow.localTextPrefix; }
        protected getService() { return AssetEsperienzeRisorseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}